import { Component, Inject, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { Subscription } from 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'sm-customer-booking-details',
  templateUrl: './customer-booking-details.component.html',
  styleUrls: ['./customer-booking-details.component.scss']
})
export class CustomerBookingDetailsComponent implements OnInit, OnDestroy {
  invoiceDetails: any = []
  private _apiSubscription: Subscription = new Subscription();
  bookingDetails: any = []
  @ViewChild('captureContainer', { static: false }) captureContainer!: ElementRef;
  constructor( @Inject(MAT_DIALOG_DATA) public parentData: any, private _apiService: ApiService) { 

    this._apiSubscription =  this._apiService.apiResult.subscribe((resData) => {
      console.log("inInvoiceBookings3:", resData)
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_BOOKING_DETAIL_BY_ID){
        this.bookingDetails = []
        if(resData.result && resData.result != null && resData.result != 'null'){
          this.bookingDetails = resData.result

          if(this.bookingDetails[0].customerInfo){
            this.bookingDetails[0].customerInfo = JSON.parse(this.bookingDetails[0].customerInfo)
            this.bookingDetails[0].customerName = this.bookingDetails[0].customerInfo.name
            this.bookingDetails[0].customerPhone = this.bookingDetails[0].customerInfo.phone
           }
          if(this.bookingDetails[0].serviceInfo){
            this.bookingDetails[0].serviceInfo = JSON.parse(this.bookingDetails[0].serviceInfo)
           }
          if(this.bookingDetails[0].custom_items && typeof this.bookingDetails[0].custom_items == 'string'){
            this.bookingDetails[0].custom_items = JSON.parse(this.bookingDetails[0].custom_items)
           }
           if(this.bookingDetails[0].appointment_products && typeof this.bookingDetails[0].appointment_products == 'string'){
            this.bookingDetails[0].appointment_products = JSON.parse(this.bookingDetails[0].appointment_products)
           }

           if(this.bookingDetails[0].paymentStatus === 0 || !this.bookingDetails[0].paymentStatus){
            this.bookingDetails[0].paymentStat = 'Due'
          }
          else if(this.bookingDetails[0].paymentStatus == 1){
            this.bookingDetails[0].paymentStat = 'Done'
          }
          else if(this.bookingDetails[0].paymentStatus == 2){
            this.bookingDetails[0].paymentStat = 'Payment in progress'
          }
          else if(this.bookingDetails[0].paymentStatus == 3){
            this.bookingDetails[0].paymentStat = 'Error in payment'
          }
          else {
            this.bookingDetails[0].paymentStat = 'N/A'
          }
          
        // }
        
        
        if(this.bookingDetails[0].bookingStartTime && this.bookingDetails[0].bookingStartTime!= null){
           this.bookingDetails[0].bookingStartTime =  this.bookingDetails[0].bookingStartTime.slice(0,5)
        }
       if(this.bookingDetails[0].bookingEndTime && this.bookingDetails[0].bookingEndTime!=null){
        this.bookingDetails[0].bookingEndTime = this.bookingDetails[0].bookingEndTime.slice(0,5)
       }
         
        if(this.bookingDetails[0].bookingStatus == 0 || this.bookingDetails[0].bookingStatus == 1 || this.bookingDetails[0].bookingStatus == 2 ){
          this.bookingDetails[0].bookingStat = 'New booking'
        }else if(this.bookingDetails[0].bookingStatus == 3){
          this.bookingDetails[0].bookingStat = 'Under process'
        }else if(this.bookingDetails[0].bookingStatus == 4){
          this.bookingDetails[0].bookingStat = 'Completed'
        }else if(this.bookingDetails[0].bookingStatus == 5){
          this.bookingDetails[0].bookingStat = 'Booking confirmed'
        }
        else if(this.bookingDetails[0].bookingStatus == 6){
          this.bookingDetails[0].bookingStat = 'Cancelled by User'
        }
        else if(this.bookingDetails[0].bookingStatus == 7){
          this.bookingDetails[0].bookingStat = 'Assigned'
        }
        else if(this.bookingDetails[0].bookingStatus == 8){
          this.bookingDetails[0].bookingStat = 'Cancelled by service provider'
        } 
        else if(this.bookingDetails[0].bookingStatus == 9){
          this.bookingDetails[0].bookingStat = 'Partially Complete'
        }
          
        }else {
          // this._apiService.addEditEntityInvoice(data)
        }
        
      }
    });
  }

  ngOnInit(): void { 
    this._apiService.getBookingDetailById(this.parentData.data)
    

  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

  captureScreenshot() {
    const element = document.getElementById('capture'); // Replace 'elementId' with the actual ID of the element you want to capture
    html2canvas(element!).then((canvas:any) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width * 0.75, canvas.height * 0.75); // You might need to adjust the dimensions
      pdf.save('screenshot.pdf');
    });
  }

  captureScreen() {

  //   html2canvas(this.captureContainer.nativeElement, {
  //     allowTaint : true,
  //     useCORS : true 
  //  }).then(canvas => {
  //     // Convert canvas to an image URL
  //     const screenshotUrl = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();
  //     pdf.addImage(screenshotUrl, 'PNG', 0, 0, canvas.width * 1, canvas.height * 1); // You might need to adjust the dimensions
  //     pdf.save('screenshot.pdf');
  //   });

  let pdf = new jsPDF('p', 'pt', 'a4')
  pdf.html(this.captureContainer.nativeElement, { callback:(pdf) => {
pdf.save("sample.pdf")
  } 
})


  }

}